



























import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import Parrot from "@/assets/images/parrot/HoldingMarker.svg?inline";
import StarRating from "vue-star-rating";
import { Getter, Action } from "vuex-class";
import { Rubric, RubricSessionAnswers, RubricAnswersByUser, RubricAnswers } from "@/types";

@Component({
  components: { Parrot, StarRating }
})
export default class ReviewRubric extends Vue {
  @Prop() private teamID!: string;
  @Prop() private sessionID!: string;
  @Prop() private isRubricFetched!: boolean;
  @Prop() private isSessionReviewed!: boolean;
  @Prop() private isManager!: boolean;

  @Prop() private scoreMap!: Map<number, number>;
  @Prop() private userScore!:number;

  @Getter private JWT!: string;
  @Getter private UID!: string;
  @Getter private rubricData!: Rubric;
  @Getter private rubricSessionAnswersByUser!: RubricAnswersByUser[];
  @Getter private rubricSessionAverageAnswers!: RubricAnswers[];

  private isApiSubmitRubric: boolean = false;
  private average: string = "average";
  private selectedReviewer: string = this.average;

  private ratingSelected(rating: number, index: number) {
    this.$emit("rubricRatingSelected", rating, index);
  }

  @Watch("rubricSessionAverageAnswers", { immediate: true })
  private onRubricSessionAverageAnswers() {
    if(!this.isManager) {
      this.onSelectReviewer("average", this.rubricSessionAverageAnswers)
    }
  }

  @Watch("rubricSessionAnswersByUser", { immediate: true })
  private onRubricSessionAnswersByUser() {
    if(this.isManager && Array.isArray(this.rubricSessionAnswersByUser)) {
      let answerIndex = this.rubricSessionAnswersByUser.findIndex(user => user.uid === this.UID);
      if(answerIndex > -1) {
        let reviewedUser = this.rubricSessionAnswersByUser[answerIndex];
        this.onSelectReviewer(reviewedUser.uid, reviewedUser.answers);
      }
    }
  }

  private onSelectReviewer(uid:string, answers: RubricAnswers[]) {

    if(answers && answers.length > 0) {
      this.selectedReviewer = uid;
    
      for (let sessionAnswers of answers) {
        let displayOrder = sessionAnswers.question.displayOrder;
        this.ratingSelected(sessionAnswers.starsRating / 2, displayOrder);
      }
    }
  }

  private createRubric() {
    if (this.teamID) {
      this.$router.push({
        name: "manageRubric",
        params: {
          teamID: this.teamID
        }
      });
    }
  }
}
